module.exports = __webpack_public_path__ + "img/bc-water-tool-logo.ee8966ad.svg";